import React from 'react';
import { Check } from 'lucide-react';

const items = {
  en: [
    'Pose and walk for castings, editorials and portraits',
    'Beauty steps for daylight, flash and evening light',
    'Colour, fabric and proportion, matched to your silhouette',
    'A lookbook you keep yourself and take to the appointment',
  ],
  de: [
    'Pose und Gang für Castings, Editorials und Portraits',
    'Beauty-Schritte für Tageslicht, Blitz und Abendlicht',
    'Farbe, Stoff und Proportion, abgestimmt auf deine Silhouette',
    'Ein Lookbook, das du selbst führst und zum Termin mitnimmst',
  ],
};

export default function TrainingGoals({ lang }) {
  const t = {
    headline:
      lang === 'de'
        ? 'DREI DISZIPLINEN, EIN KLARER WEG'
        : 'THREE DISCIPLINES, ONE CLEAR PATH',
    sub:
      lang === 'de'
        ? 'Mode, Beauty und Modelpräsenz, geübt in kurzen Einheiten, die du wiederholen kannst.'
        : 'Fashion, beauty and model presence, practised in short units you can repeat.',
  };

  return (
    <section className="bg-stone-100 py-20 lg:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-rose-100 text-rose-900 text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            {lang === 'de' ? 'Das Atelier' : 'The atelier'}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-stone-900 tracking-tight">
            {t.headline}
          </h2>
          <p className="mt-4 text-lg text-stone-500 max-w-xl mx-auto">{t.sub}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {items[lang].map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white rounded-2xl px-6 py-5 shadow-sm border border-stone-200 hover:shadow-md hover:border-rose-200 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-stone-900 flex items-center justify-center mt-0.5">
                <Check size={16} color="white" strokeWidth={3} />
              </div>
              <p className="text-stone-700 font-medium text-base leading-snug">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
